import { useEffect } from "react";
import { loadScript } from "./EmbedUtils";
import React from "react";

export function TwitterEmbed({twitterURL}:{twitterURL?:string}) {

    useEffect(() => {
        if (!loadScript("https://platform.x.com/widgets.js", "twitter-embed-script")) {
            let wind = window as any;
            if (wind.twttr && wind.twttr.widgets && typeof wind.twttr.widgets.load === "function") {

                wind.twttr.widgets.load();

            }
        }
    }, []);


   return (
       <>
           <a className="twitter-timeline" href={`https://x.com/${twitterURL}?ref_src=twsrc%5Etfw`}>Tweets by {twitterURL}</a>

       </>
   );

}
